const OneTrustScript = () => {
  const key = process.env.ONE_TRUST_KEY || null;
  if (!key) return null;
  return (
    <>
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={key}
        async
      ></script>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() { }`,
        }}
      />
    </>
  );
};

export default OneTrustScript;
